import { useState } from "react";
import { ErrorApi } from "../api.ts";

export interface SinConsentimiento { razon: "papel" | "urgencia"; detalle: string }

/**
 * Se muestra cuando el servidor no deja firmar una cirugía, un implante o una endodoncia porque falta el consentimiento informado firmado (Formulario 024).
 * Ofrece lo correcto: registrar el consentimiento. Y, si el paciente lo firmó en papel o fue una urgencia, declararlo con una explicación (queda en la historia).
 * Si el paciente NEGÓ o REVOCÓ el consentimiento no hay forma de saltarse la regla, y el mensaje del servidor ya lo explica.
 */
export function FaltaConsentimiento({ error, ocupado, alFirmarSin }: { error: unknown; ocupado: boolean; alFirmarSin: (x: SinConsentimiento) => void }) {
  const [razon, setRazon] = useState<SinConsentimiento["razon"]>("papel");
  const [detalle, setDetalle] = useState("");
  if (!(error instanceof ErrorApi) || error.datos?.codigo !== "falta_consentimiento") return null;
  return (
    <div className="aviso info" role="group" aria-label="Falta el consentimiento informado" style={{ display: "grid", gap: 8 }}>
      <b>Cómo continuar</b>
      <span>Lo correcto es registrar el consentimiento informado del paciente en <b>Documentos → Consentimientos</b> y volver a firmar. Si no es posible, declara el motivo; quedará escrito en la historia clínica y en la auditoría.</span>
      <div className="fila" style={{ gap: 6, flexWrap: "wrap" }} role="radiogroup" aria-label="Motivo">
        <button type="button" className="tog" aria-pressed={razon === "papel"} onClick={() => setRazon("papel")}>El paciente lo firmó en papel</button>
        <button type="button" className="tog" aria-pressed={razon === "urgencia"} onClick={() => setRazon("urgencia")}>Fue una urgencia</button>
      </div>
      <label className="campo">{razon === "papel" ? "¿Dónde queda el formulario firmado? (folio de la historia física, archivo…)" : "¿Por qué fue una urgencia?"}
        <input value={detalle} maxLength={300} onChange={(e) => setDetalle(e.target.value)} aria-label="Explicación" /></label>
      <div><button type="button" className="btn chico" disabled={ocupado || detalle.trim().length < 5} onClick={() => alFirmarSin({ razon, detalle: detalle.trim() })}>Firmar sin consentimiento registrado</button></div>
    </div>
  );
}
